import { Browser } from '@syncfusion/ej2-base';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import { AccumulationChart, IAccLoadedEventArgs, AccumulationTheme} from '@syncfusion/ej2-angular-charts';
import { EventEmiterService } from '../../../../../src/app/shared/services/event-emiter.service';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { MenuFuncionService, MovimientoService } from '../../../../../src/app/shared/services';
import { DashboardMovimientosPorTipoMovimientoRequest, LocalStorageKeys, MenuFuncionCodes } from '../../../../../src/app/shared/model';

@Component({
  selector: 'app-movimiento-tipo-movimientos',
  templateUrl: './movimiento-tipo-movimientos.component.html',
  styleUrls: ['./movimiento-tipo-movimientos.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class MovimientoTipoMovimientosComponent implements OnInit, OnDestroy {
  chart: AccumulationChart;
  canView: boolean = false;
  isValidating: boolean = false;
  isSearching: boolean = false;

  searchForm: FormGroup;

  categoriaList: any[];

  public data:Object[] = [];
  // Initializing Legend
  public legendSettingsMovimientoTipoMovimiento?: Object;
  public tooltipMovimientoTipoMovimiento?: Object;

  // custom code start
  public load(args: IAccLoadedEventArgs): void {
    let selectedTheme: string = location.hash.split('/')[1];
    selectedTheme = selectedTheme ? selectedTheme : 'Material';
    args.accumulation.theme = <AccumulationTheme>(
      (selectedTheme.charAt(0).toUpperCase() +
        selectedTheme.slice(1)).replace(/-dark/i, 'Dark').replace(/contrast/i, 'Contrast')
    );
  }

  // custom code end
  public startAngle: number = Browser.isDevice ? 55 : 35;
  public radius: string = Browser.isDevice ? '50%' : '70%'
  public enableAnimation: boolean = true;

  private subscription: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private menuService: MenuFuncionService,
    private sharedFunctions: SharedFunctions,
    private movimientoService: MovimientoService,
    private eventEmitterService: EventEmiterService
  ) {
    this.subscription = this.eventEmitterService.reloadView$.subscribe((value) => {
      this.loadView()
    });
  }

  ngOnInit() {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.DASHBOARD_MOVIMIENTOS_TIPO_MOVIMIENTO).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        this.canView = true;
        this.loadView();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'Signo': [null]
    });
  }

  loadView() {
    var tenantId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId);
    if (tenantId != null && tenantId.length > 0) {
      this.buildForm();
      this.getCategorias();
      this.onSearch();
    }
    else {
      setTimeout(() => this.loadView(), 1000);
    }
  }

  onSearch() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    var r = new DashboardMovimientosPorTipoMovimientoRequest(cId, null);
    r = { ...r, ...this.searchForm.getRawValue() }

    this.isSearching = true;
    this.movimientoService.obtenerDashboardMovimientosPorTipoMovimiento(r).subscribe((response) => {
      this.isSearching = false;
      if (response != null && response.Success) {
        this.legendSettingsMovimientoTipoMovimiento = {
          width: '200', height: '250',shapeHeight: 15, shapeWidth: 15
        };
        this.tooltipMovimientoTipoMovimiento = {
          enable: true
        }

        this.data = response.Result?.Grupos;
      }
    },
    (err: HttpErrorResponse) => {
      this.isSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getCategorias() {
    this.categoriaList = [
      { Id: -1, Nombre: "Ver solo deudas" },
      { Id: 1, Nombre: "Ver solo pagos" }
    ];
  }
}
